module.exports = __webpack_public_path__ + "img/user-history.5bd8ae1c.svg";